"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CalendarNavigation", {
    enumerable: true,
    get: function() {
        return CalendarNavigation;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
const _ri = require("react-icons/ri");
const _localisationeq1 = require("@equiem/localisation-eq1");
const _Theme = require("../../contexts/Theme");
const _Button = require("../Button/Button");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const CalendarNavigation = (param)=>{
    let { loading, prev, next, reset } = param;
    const theme = (0, _Theme.useTheme)();
    const { t } = (0, _localisationeq1.useTranslation)();
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "f2a31e2bf67ab468",
                [
                    theme.colors.border,
                    theme.borderRadius
                ]
            ]
        ]) + " " + "navigation"
    }, /*#__PURE__*/ _react.default.createElement(_Button.Button, {
        className: "prev-week pr-0",
        type: "button",
        variant: "link",
        disabled: loading,
        onClick: prev
    }, /*#__PURE__*/ _react.default.createElement(_ri.RiArrowLeftSLine, null)), /*#__PURE__*/ _react.default.createElement(_Button.Button, {
        className: "today",
        type: "button",
        variant: "link",
        disabled: loading,
        onClick: reset
    }, /*#__PURE__*/ _react.default.createElement("small", {
        className: _style.default.dynamic([
            [
                "f2a31e2bf67ab468",
                [
                    theme.colors.border,
                    theme.borderRadius
                ]
            ]
        ])
    }, t("common.today"))), /*#__PURE__*/ _react.default.createElement(_Button.Button, {
        className: "next-week pl-0",
        type: "button",
        variant: "link",
        disabled: loading,
        onClick: next
    }, /*#__PURE__*/ _react.default.createElement(_ri.RiArrowRightSLine, null))), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "f2a31e2bf67ab468",
        dynamic: [
            theme.colors.border,
            theme.borderRadius
        ]
    }, ".navigation.__jsx-style-dynamic-selector{display:inline-block;border:1px solid ".concat(theme.colors.border, ";-webkit-border-radius:").concat(theme.borderRadius, ";-moz-border-radius:").concat(theme.borderRadius, ";border-radius:").concat(theme.borderRadius, "}.navigation.__jsx-style-dynamic-selector button{padding-top:6px;padding-bottom:6px}.navigation.__jsx-style-dynamic-selector small.__jsx-style-dynamic-selector{text-transform:uppercase}")));
};

//# sourceMappingURL=CalendarNavigation.js.map